import { SVGMap } from 'react-svg-map';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import * as frontDiagram from './front.json';
import * as backDiagram from './back.json';

import styles from './index.module.css';
import { Side } from '../../../utils/enum';

interface Props extends WithTranslation {
  side: Side;
  values: string[];
  onChange: (values: string[]) => void;
  clearAllNonMatched?: boolean;
}

const BodyDiagramInput: React.FC<Props> = ({ side, onChange, values, t }) => {
  const isFrontView = side === Side.Front;
  const map = isFrontView ? frontDiagram : backDiagram;
  const screenLeftString = isFrontView ? t('Front right') : t('Back left');
  const screenRightString = isFrontView ? t('Front left') : t('Back right');
  return (
    <div className={styles.DiagramContainer}>
      <div className={styles.SideLabelsStyle}>
        <div>{screenLeftString} </div>
        <div>{screenRightString}</div>
      </div>
      <SVGMap
        map={map}
        isLocationSelected={(target) => values.includes(target.id)}
        onLocationClick={(e) => {
          const location = e.nativeEvent.target.id;
          if (values.includes(location)) {
            onChange(
              values.filter(
                (selectedLocation) => selectedLocation !== location,
              ),
            );
          } else {
            onChange([...values, location]);
          }
        }}
      />
    </div>
  );
};

export default withTranslation()(BodyDiagramInput);
